export default __webpack_public_path__ + "static/media/Arrow-right.7f5eeeaf.svg";